/**
 * Experiment/feature flag key registry.
 * All experiment and feature flag keys managed through the experimentation system.
 * Use these keys instead of literal strings everywhere.
 */
const ExperimentKey = Object.freeze({
    /** @deprecated Expired Jan 2025. Backend callers still reference this — clean up separately. */
    FreeTrainGpu: "free-train-gpu",
    /** @deprecated Continuous Improvement is now GA — feature flag and experiment checks removed. */
    ContinuousImprovementRollout: "continuous-improvement-rollout",
    /** @deprecated Ended — collapsible features are now always on. */
    TrialModalCollapsibleFeatures: "trial-modal-collapsible-features",
    /** @deprecated Ended — model eval CTA is now always on for eligible users. */
    TrialAlertModelEvalCTA: "trial-alert-model-eval-cta",
    /** @deprecated Ended — usage dashboard is now GA for all users. */
    CreditUsageDashboard: "usage-dashboard-holdback-test",
    /** @deprecated Ended — usage projection is now GA for all users. */
    UsageCostProjection: "usage-cost-projection",
    /** Rolls out the new unified annotation editor on the core app /imagePreview route. */
    NewAnnotationEditor: "new-annotation-editor"
});

module.exports = { ExperimentKey };
